var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOutlineReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.707 12.847l.097.008 3.562.597c.456.075.765.51.69.97-.069.414-.424.707-.827.707-.045 0-.091-.004-.138-.012l-1.377-.23c1.043 1.846 3.035 3.024 5.228 3.024 2.48 0 4.665-1.45 5.567-3.694.174-.433.663-.641 1.091-.466.43.174.637.667.462 1.1-1.16 2.884-3.955 4.749-7.12 4.749-2.86 0-5.459-1.58-6.77-4.043l-.31 1.665c-.075.406-.427.69-.824.69-.05 0-.103-.006-.155-.016-.455-.085-.754-.527-.668-.986l.627-3.377c.01-.053.04-.096.058-.145.021-.053.034-.112.065-.16.02-.03.05-.052.074-.08.048-.055.092-.113.152-.154.01-.007.022-.008.031-.014.081-.054.168-.095.265-.116h.033c.093-.016.186-.025.284-.009zM12.058 4.4c2.86 0 5.459 1.58 6.77 4.043l.31-1.666c.085-.458.524-.76.978-.673.455.085.755.527.67.986l-.628 3.377c-.011.059-.039.108-.06.16-.016.037-.022.078-.043.112-.031.053-.076.096-.117.141-.024.026-.042.057-.069.08-.05.04-.109.069-.166.098-.028.013-.052.035-.082.045-.09.034-.187.052-.286.052-.046 0-.092-.003-.139-.011l-3.562-.596c-.456-.076-.765-.51-.69-.97.076-.46.507-.775.965-.695l1.377.23c-1.043-1.846-3.035-3.024-5.228-3.024-2.48 0-4.665 1.45-5.567 3.694-.132.33-.446.528-.777.528-.105 0-.211-.02-.314-.062-.43-.174-.637-.667-.462-1.1C6.098 6.266 8.893 4.4 12.058 4.4z",
    transform: "translate(-310 -617) translate(310 617)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlineReview);
export default __webpack_public_path__ + "static/media/icon-outline-review.95b425e404b54f8993c16b37c7aab9e9.svg";
export { ForwardRef as ReactComponent };